import React, { Component } from 'react'
import {MasterLayout} from 'layout';
import { Input, DropDown } from 'components/tt-forms/common';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { Link, browserHistory } from 'react-router';
import { RowItemLichSuXuLy } from 'modules/thanh-tra-trung/datatable';
import { ThanhTra } from 'api';
import { connect } from 'react-redux';
import { Button } from "@blueprintjs/core";
import {isEmpty, get} from 'lodash';

class DanhSachLichSuXuLyTTT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      namThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      dataLichSuXuLy: [],
      dsNamThanhTra: [],
      soQuyetDinh: '',
    }
  }

  async componentDidMount() {
    await this.checkNamThanhTraXuLy();
    this.getNamThanhTra();
    this.getLichSuXuLyCTTT();
  }

  async checkNamThanhTraXuLy() {
    await ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(async res => {
      if (!isEmpty(res.data)) {
        await this.setState({
          namThanhTra: get(res, 'data.namThanhTra')
        });
      }
    });
  }

  getNamThanhTra() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dsNamThanhTra: res.data
        });
      }
    });
  }

  getLichSuXuLyCTTT() {
    this.setState({
      tableLoading: true
    })
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size
    };
    if (this.state.namThanhTra) {
      params.namThanhTra = this.state.namThanhTra;
    }

    if (this.state.soQuyetDinh) {
      params.soQuyetDinhPheDuyet = this.state.soQuyetDinh;
    }
    ThanhTra.actions.getLichSuXuLyCTTTrung.request('', params).then(res => {
      if (!isEmpty(res.data._embedded)) {
        let data = res.data._embedded;
        this.setState({
          dataLichSuXuLy: data.lichSuXuLyCTTTrungs,
          tableLoading: false
        });
      } else {
        this.setState({
          dataLichSuXuLy: [],
          tableLoading: false
        })
      }
    });
  }


  goBack () {
    browserHistory.goBack();
  }
  onChange (name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  handleSearch() {
    this.getLichSuXuLyCTTT();
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="back-foward mb0">
            <span className='arrow-left txt-blue txt-underline' onClick={this.goBack.bind(this)}>Về trang trước</span>
          </div>
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách lịch sử xử lý thanh tra/kiểm tra trùng</p>
            </div>
          </div>
          <div className="bottom-content">
            <div className='wrap-block search_form_lichsu'>
              <div className='row plr10'>
                <div className='col-83 no-gutter'>
                  <div className="search_form_ttt">
                    <DropDown className='col-25' label='Năm thanh tra/kiểm tra' options={this.state.dsNamThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder/>
                    <Input className='col-25' label='Số quyết định phê duyệt KHTT/KHKT' placeholder='Nhập...' value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh' maxLength={255}/>
                    <Button className='btn-green ttt-search' text="Tìm kiếm" onClick={this.handleSearch.bind(this)} disabled={ this.state.searching ? 'disabled' : '' } />
                  </div>
                </div>
              </div>
            </div>
              <DataTable
                header={header.thanhTraTrung.DSLSXLTTT}
                dataList={this.state.dataLichSuXuLy}
                thanhTra
                hideButtonExport
                hidePagination
                pageData={this.state.pageData}
                parent={this}
                search
                tableLoading={this.state.tableLoading}>
                <RowItemLichSuXuLy />
              </DataTable>
          </div>
          <div className="box-bottom ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.goBack.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

DanhSachLichSuXuLyTTT.defaultProps = {
  namThanhTra: []
}

const mapStateToProps = state => ({
  namThanhTra: state.danhSachKHThanhTra.namThanhTra
});

export default connect(mapStateToProps)(DanhSachLichSuXuLyTTT)



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/DanhSachLichSuXuLyTTT.jsx